import { Node_Type } from "./../../ricos-types";
import Caption from "../../_shared/figure/viewer-caption";
import Giphy from "./viewer-giphy";
const nodeViewRenderers = {
  [Node_Type.GIF]: Giphy,
  [Node_Type.CAPTION]: Caption
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
